import React from "react";
import { Container, ContentArea, PageTitle } from "./styles";
import Header from "../../components/Header";
import IconsBar from "../../components/IconsBar/IconsBar";
import { RegisterTabs } from "../../components/RegisterTabs/RegisterTabs";

export const Registration = () => {
  return (
    <Container>
      <Header />
      <IconsBar />
      <ContentArea>
        <PageTitle>Registro de Matrículas</PageTitle>
        <RegisterTabs />
      </ContentArea>
    </Container>
  );
};
